import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';  // 引入 Vuex store
import { MessageBox } from 'element-ui';

Vue.use(Router);

const router = new Router({
  mode: 'history', // 使用 HTML5 History 模式，去掉 # 号
  routes: [
    {
      path: '/',
      component: () => import('../pages/AppLayout.vue'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('../pages/HomePage.vue'),
          meta: { title: '首页' },
        },
        {
          path: '/Login',
          name: 'Login',
          component: () => import('../pages/LoginPage.vue'),
          meta: { title: '登录' },
        },
        {
          path: '/Reg',
          name: 'Reg',
          component: () => import('../pages/RegPage.vue'),
          meta: { title: '注册' },
        },
        {
          path: '/ResetPwd',
          name: 'ResetPwd',
          component: () => import('../pages/ResetPwdPage.vue'),
          meta: { title: '重置密码' },
        },
        {
          path: '/MyClass',
          name: 'MyClass',
          component: () => import('../pages/student/MyClass.vue'),
          meta: { title: '我的课程', requiresAuth: true, requiresStudentBinding: true },
        },
        {
          path: '/ClassDetail/:id',
          name: 'ClassDetail',
          component: () => import('../pages/student/ClassDetail.vue'),
          meta: { title: '课程详情', requiresAuth: true, requiresStudentBinding: true },
        }
        ,
        {
          path: '/HomeworkDetail/:id',
          name: 'HomeworkDetail',
          component: () => import('../pages/student/HomeworkDetail.vue'),
          meta: { title: '作业详情', requiresAuth: true, requiresStudentBinding: true },
        },
        {
          path: '/HomeworkProblem/:problem_id',
          name: 'HomeworkProblem',
          component: () => import('../pages/student/HomeworkProblem.vue'),
          meta: { title: '作业题目', requiresAuth: true, requiresStudentBinding: true },
        },
        {
          path: '/ProblemList',
          name: 'ProblemList',
          component: () => import('../pages/problem/ProblemList.vue'),
          meta: { title: '题库', requiresAuth: true },
        },
        {
          path: '/ProblemDetail/:problem_id',
          name: 'ProblemDetail',
          component: () => import('../pages/problem/ProblemDetail.vue'),
          meta: { title: '题目详情', requiresAuth: true },
        },
        {
          path: '/ProblemHistory/:problem_id',
          name: 'ProblemHistory',
          component: () => import('../pages/problem/ProblemHistory.vue'),
          meta: { title: '题目提交记录', requiresAuth: true },
        },
        {
          path: '/User',
          name: 'UserHome',
          component: () => import('../pages/user/UserHome.vue'),
          meta: { title: '个人中心', requiresAuth: true },
        }
        ,
        {
          path: '/NewsDetail/:id',
          name: 'NewsDetail',
          component: () => import('../pages/NewsDetail.vue'),
          meta: { title: '新闻详情' },
        }
        ,
        {
          path: '/CompetitionList',
          name: 'CompetitionList',
          component: () => import('../pages/Competition/CompetitionList.vue'),
          meta: { title: '比赛' },
        }
        ,
        {
          path: '/CompetitionDetail/:competition_id',
          name: 'CompetitionDetail',
          component: () => import('../pages/Competition/CompetitionDetail.vue'),
          meta: { title: '比赛详情' },
        }
        ,
        {
          path: '/CompetitionProblem/:competition_id/:problem_id',
          name: 'CompetitionProblem',
          component: () => import('../pages/Competition/CompetitionProblem.vue'),
          meta: { title: '题目详情'},
        },
        {
          path: '/TeaQuestionSheetList',
          name: 'TeaQuestionSheetList',
          component: () => import('../pages/questionSheet/TeaQuestionSheetList.vue'),
          meta: { title: '教学题单', requiresAuth: true, requiresStudentBinding: true },
        },
        {
          path: '/BasQuestionSheetList',
          name: 'BasQuestionSheetList',
          component: () => import('../pages/questionSheet/BasQuestionSheetList.vue'),
          meta: { title: '用户题单', requiresAuth: true },
        },
        {
          path: '/BasQuestionSheetDetail',
          name: 'BasQuestionSheetDetail',
          component: () => import('../pages/questionSheet/BasQuestionSheetDetail.vue'),
          meta: { title: '用户题单详情', requiresAuth: true },
        }
        ,
        {
          path: '/BasProblemDetail/:sheet_id/:problem_id',
          name: 'BasProblemDetail',
          component: () => import('../pages/questionSheet/BasProblemDetail.vue'),
          meta: { title: '题目详情', requiresAuth: true },
        },
        {
          path: '/TeaQuestionSheetDetail',
          name: 'TeaQuestionSheetDetail',
          component: () => import('../pages/questionSheet/TeaQuestionSheetDetail.vue'),
          meta: { title: '教学题单详情', requiresAuth: true },
        }
        ,
        {
          path: '/TeaProblemDetail/:sheet_id/:problem_id',
          name: 'TeaProblemDetail',
          component: () => import('../pages/questionSheet/TeaProblemDetail.vue'),
          meta: { title: '题目详情', requiresAuth: true },
        }       
       ,
        {
          path: '/MyOnlineCourse',
          name: 'MyOnlineCourse',
          component: () => import('../pages/onlineCourse/MyOnlineCourse.vue'),
          meta: { title: '我的线上视频课', requiresAuth: true },
        }
        ,
        {
          path: '/OnlineCourseDetail/:id',
          name: 'OnlineCourseDetail',
          component: () => import('../pages/onlineCourse/OnlineCourseDetail.vue'),
          meta: { title: '线上视频课详情', requiresAuth: true },
        }
      ]
    },
    {
      path: '/DocViewer',
      name: 'DocViewer',
      component: () => import('../pages/DocViewer.vue'),
      meta: { title: '文档查看' },
    },
    {
      path: '/outside/CompetitionDetail/:competition_id',
      name: 'OutsideCompetitionDetail',
      component: () => import('../pages/Competition/outside/CompetitionDetail.vue'),
      meta: { title: '比赛详情' },
    },
    {
      path: '/outside/CompetitionProblem/:competition_id/:problem_id',
      name: 'OutsideCompetitionProblem',
      component: () => import('../pages/Competition/outside/CompetitionProblem.vue'),
      meta: { title: '题目详情'},
    },
  ]
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn;
  const isStudentBound = store.getters.isStudentBound;

  // 检查目标路由是否需要授权
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.name === 'Login') {
      // 如果目标页面是登录页面，不需要进一步检查
      next();
    } else if (!isLoggedIn) {
      // 如果用户未登录并且目标页面需要授权，重定向到登录页面
      MessageBox.alert("此功能需要登录才可以访问", "登录提示", {
        confirmButtonText: '确认',
        type: "warning",
      }).catch(() => { })

      next({ name: 'Login' });
    } else if (to.matched.some(record => record.meta.requiresStudentBinding) && !isStudentBound) {
      // 如果目标页面需要绑定学员账号并且用户未绑定，重定向到绑定页面

      MessageBox.alert("访问此功能需要先绑定学员信息", "绑定提示", {
        confirmButtonText: '确认',
        type: "warning",
      }).catch(() => { })

      next({ name: 'UserHome', hash: "#userinfo" });
    } else {
      next(); // 允许导航
    }
  } else {
    next(); // 允许导航
  }
});


router.afterEach((to) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + "-编程兔";
  }
});


export default router;